import React, { useState, useCallback } from "react";
import { postApi } from "../../../services/api/postApi";
import "./PostForms.css";

const QuestionPostForm = ({ onSuccess, onCancel }) => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [tags, setTags] = useState("");
  const [difficulty, setDifficulty] = useState("intermediate");
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!title.trim()) {
        alert("Please enter a question title");
        return;
      }

      const tagsArray = tags
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean)
        .slice(0, 5); // Max 5 tags

      setLoading(true);
      try {
        const response = await postApi.createPost({
          postType: "question",
          content: body.trim(),
          question: {
            title: title.trim(),
            tags: tagsArray,
            difficulty,
          },
          visibility: "public",
        });

        if (onSuccess) {
          onSuccess(response.data.post || response.data);
        }

        // Reset form
        setTitle("");
        setBody("");
        setTags("");
        setDifficulty("intermediate");
      } catch (error) {
        alert(error.response?.data?.message || "Failed to create question");
      } finally {
        setLoading(false);
      }
    },
    [title, body, tags, difficulty, onSuccess]
  );

  return (
    <form onSubmit={handleSubmit} className="question-post-form post-form">

      {/* Question Title */}
      <div className="form-group">
        <label htmlFor="question-title">Question Title *</label>
        <input
          id="question-title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="What is your question?"
          maxLength={300}
          required
        />
        <small className="char-count">{title.length}/300 characters</small>
      </div>

      {/* Question Body */}
      <div className="form-group">
        <label htmlFor="question-body">Details (Optional)</label>
        <textarea
          id="question-body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Provide additional context, what you've tried, expected results..."
          rows={6}
          maxLength={10000}
        />
        <small className="char-count">{body.length}/10000 characters</small>
      </div>

      {/* Tags */}
      <div className="form-group">
        <label htmlFor="question-tags">Tags</label>
        <input
          id="question-tags"
          type="text"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          placeholder="machine-learning, python, statistics (comma-separated)"
        />
        <small>Add up to 5 tags to categorize your question</small>
      </div>

      {/* Difficulty Level */}
      <div className="form-group">
        <label htmlFor="difficulty-level">Difficulty Level</label>
        <select
          id="difficulty-level"
          value={difficulty}
          onChange={(e) => setDifficulty(e.target.value)}
        >
          <option value="beginner">Beginner</option>
          <option value="intermediate">Intermediate</option>
          <option value="advanced">Advanced</option>
        </select>
      </div>

      <div className="form-actions">
        <button type="button" onClick={onCancel} className="cancel-btn">
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading || !title.trim()}
          className="submit-btn"
        >
          {loading ? "Posting..." : "Post Question"}
        </button>
      </div>
    </form>
  );
};

export default React.memo(QuestionPostForm);








